import { userService } from '@/services/user'
import { setupService } from '@/services/setup'
import { acoToAES, aesToAco, validateObject } from '@/helpers/acoData'
import router from '../../router'
import { profileService } from '@/services/profiles'
import convertAddress from '@/helpers/addressConvert'

const state = {
  address: {},
  card: {},
  phone: null,
  name: null,
} // // TODO: HAVE TO FIX name being set to email

const actions = {
  step1({ commit, dispatch }, { name, phone, email }) {
    commit('setStep1', { name, phone, email })
    userService.updateProfile({ name, phone, email })
      .then(resp => {
        console.log(`updateProfile resp:`, resp)
        router.push('/signup2')
      })
      .catch(e => console.error(e))
  },
  step2({ commit }, payload) {
    console.log(`saving billingAddress via step2 action`)
    let { billingAddress } = payload
    commit('setAddress', billingAddress)
    setupService.setBilling({ billingAddress })
      .then((resp) => {
        console.log(`set billing response`, resp)
        router.push('/signup3')
      })
  },
  async step3({ commit, state, rootState }, payload) {
    // in this one we have to update stripe to have a card as well as save the profile
    // card should be an object with name,number,zip,month,year,code
    let { card, token } = payload
    let { info } = rootState.auth.user
    if (!info) {
      console.error(`no info object on user in auth state`)
    }
    let { email } = info
    if (!card || !token) return console.error(`no card or no token generated`)
    if (!card.number || !card.month || !card.year || !card.code) return this.router.push('/signup3')
    console.log(`running step 3 for user ${email}`)
    let profile = createProfile(state, card, email, info)
    console.log(`built profile`, profile)
    let validProfile = validateObject(profile)
    if (!validProfile) return router.push('/signup2')
    let encryptedProfile = acoToAES(profile)
    // now we do the following - set billing in stripe and create profile on account
    let billingResp = await setupService.setBilling({ token })
    console.log(`billingresp`, billingResp)
    console.log(`set customer stripe card, customer_id should be in db now`)
    let profileResp = await profileService.addProfile(encryptedProfile)
    console.log(`profileResp-`, profileResp)
    console.log(`set profile for user!`)
    console.log(`all good to go now,redirecting to shop`)
    router.push('/signupcomplete')




  }
}

function createProfile(state, card, email, info) {
  let { name, phone, address } = state // TODO get name and phone from userInfo instead of state
  if (!name) name = info.name
  if (!phone) phone = info.phone
  if (!address && info.billingAddress) address = convertAddress(info.billingAddress)
  console.log('create profile calld w', state, card, email)
  if (!name || !phone || !address) return console.error('missing name or phone or address')
  let firstName = name.split(' ')[0]
  let lastName = name.split(' ')[1]
  let baseShip = {
    firstName: firstName,
    lastName: lastName,
    address1: address.address1,
    address2: address.address2 || '',
    // address3: '',
    city: address.city,
    zip: address.zip,
    state: address.state,
    country: address.country,
  }
  let profile = {
    shipping: baseShip,
    billing: baseShip,
    email: email,
    phone: phone,
    card: card,
  }
  return profile
}
const mutations = {
  setAddress(state, payload) {
    state.address = payload
  },
  setStep1(state, payload) {
    state.name = payload.name
    state.phone = payload.phone
    if (payload.email) state.email = payload.email
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}